import * as React from 'react';
import { StyleProp, View, ViewStyle } from 'react-native';
import Svg, { Path } from 'react-native-svg';

const MB_SVG_Trash = React.memo((props: {
    /**
     * The size of the component.
     */
    size?: number,

    /**
     * The color of the component.
     */
    color?: string,

    /**
     * The style of the component's container.
     */
    containerStyle?: StyleProp<ViewStyle>
}) => {
    return (
        <View style={props.containerStyle}>
            <Svg
                width={props.size ?? 24}
                height={props.size ?? 24}
                viewBox="0 0 24 24"
                fill="none"
                stroke={props.color ?? 'white'}
                strokeWidth={2}
                strokeLinecap="round"
                strokeLinejoin="round"
            >
                <Path d="M3 6L5 6 21 6" />
                <Path d="M19 6v14a2 2 0 01-2 2H7a2 2 0 01-2-2V6m3 0V4a2 2 0 012-2h4a2 2 0 012 2v2" />
                <Path d="M10 11L10 17" />
                <Path d="M14 11L14 17" />
            </Svg>
        </View>
    );
});

export { MB_SVG_Trash };
